<template>
  <div class="TupianDownBtn"
  >
    <no-ssr>
      <!--  图片 v-show="tupianItem.package != 1" -->
      <div class="tupian-btn-group" v-show="tupianItem.package != 1"
      >
        <i class="mask"/>

        <template v-if="!isLogin">
          <div
              class="tupian-btn free"
              @click="downloadFree(tupianItem)"
          >
            免费下载
          </div>
        </template>

        <div v-else>
          <template v-if="personVipState != 1 && businessVipState != 1  && companyVipState != 1 ">
            <div
                class="tupian-btn free"
                @click="downloadFree(tupianItem)"
                v-if=" vipType >= tupianItem.layer"
            >
              免费下载
            </div>
            <div v-else :class="['tupian-btn free tupian-btn-1',{ 'COMPANY' : companyVipState == 1 }]"
                 @click="download(tupianItem)"
            >
              下载{{ tupianItem.file_type }}
            </div>

          </template>

          <div v-else :class="['tupian-btn free tupian-btn-1',{ 'COMPANY' : companyVipState == 1 }]"
               @click="download(tupianItem)"
          >
            下载{{ tupianItem.file_type }}
          </div>

        </div>

        <div :class="['tupian-btn file tupian-btn-2',{ 'COMPANY' : companyVipState == 1 }]"
             @click="downloadSourceFiles(tupianItem)"
        >下载源文件
        </div>
      </div>


      <!--  图片包  -->
      <div class="tupian-package-btn-group" v-show="tupianItem.package == 1">
        <!-- 未购买 -->
        <template
            v-if="!isLogin || tupianItem.is_buy != 1 || companyVipState != 1 ||  (businessVipState == 1 && businessVipInfo.vip != 5)">
          <div
              class="tupian-btn plain tupian-btn-1"
              @click="buyBusinessVip"
          >{{ "购买商用包年VIP" }}
          </div>
          <div
              class="tupian-btn package-info tupian-btn-2"
              @click="buyTupianPackage(tupianItem)"
          >
            <div class="pic-price">
              <span class="pic-child-num">此包</span>
              <i class="text-dollar">¥</i>
              <span class="text-price">{{ tupianItem.package_price }}</span>
              <span class="pic-child-num">/{{ tupianItem.pic_num - 1 }}张</span>
            </div>
          </div>
        </template>

        <!-- 已购买 -->
        <template
            v-if="tupianItem.is_buy == 1 || companyVipState == 1 || (businessVipState == 1 && businessVipInfo.vip == 5)">
          <div
              class="tupian-btn plain plain-down tupian-btn-1"
              @click="downloadTupianPackage(tupianItem)"
          >{{ "原图打包下载" }}
          </div>
          <div class="tupian-btn  file-down tupian-btn-2"
               @click="downloadTupianPackageSourceFiles(tupianItem)"
          >{{ "源文件打包下载" }}
          </div>
        </template>
      </div>


    </no-ssr>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {getCookie} from "@/utils/auth";
import {fnLogin} from "@/fn";

export default {
  name: "TupianDownBtn",
  computed: {
    ...mapState('user',
        [
          'isLogin',
          'personVipState',
          'personVipInfo',
          'businessVipState',
          'businessVipInfo',
          'companyVipState',
          'companyVipInfo',
          'isHasUserCoupon',
          'isSwitchAccountType',
          'isSwitchCompanyMain',
        ]
    ),
  },
  watch: {
    isSwitchAccountType: {
      handler(n, o) {
        console.log(n)
        if (n == true) {
          // console.log('-- PicButtonGroup isSwitchAccountType --')
          setTimeout(() => {
            this.init();
          }, 500)
        }
      }
    },

    isSwitchCompanyMain: {
      handler(n, o) {
        console.log(n)
        if (n == true) {
          // console.log('-- PicButtonGroup isSwitchCompanyMain --')
          setTimeout(() => {
            this.init();
          }, 500)
        }
      }
    },
  },
  data() {
    return {
      // state: getCookie('companyVipState') || -1
      vipType: -1,
    }
  },
  props: {
    // 单个图片信息
    tupianItem: {
      type: Object,
      default: () => {
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.vipType = this.getUserMaxVip();
    },
    getUserMaxVip() {
      let personVipState = getCookie('personVipState')
      let businessVipState = getCookie('businessVipState')
      let companyVipState = getCookie('companyVipState')

      if (companyVipState == 1) {
        return 4
      } else if (businessVipState == 1) {
        return 3
      } else if (personVipState == 1) {
        return 2
      } else {
        return 1
      }
    },

    downloadFree(tupianItem) {
      if (fnLogin.checkLogin()) {
        this.$emit('downloadFree', tupianItem, 1);
      } else {
        fnLogin.loginIntercept(false);
      }
    },
    download(tupianItem) {
      if (fnLogin.checkLogin()) {
        this.$emit('download', tupianItem, 1);
      } else {
        fnLogin.loginIntercept(false);
      }
    },
    downloadSourceFiles(tupianItem) {
      if (fnLogin.checkLogin()) {
        this.$emit('downloadSourceFiles', tupianItem, 2);
      } else {
        fnLogin.loginIntercept(false);
      }

    },

    buyBusinessVip(tupianItem) {
      if (fnLogin.checkLogin()) {
        this.$emit('buyBusinessVip', tupianItem, 2);
      } else {
        fnLogin.loginIntercept(false);
      }
    },

    buyTupianPackage(tupianItem) {
      if (fnLogin.checkLogin()) {
        this.$emit('buyTupianPackage', tupianItem, 2);
      } else {
        fnLogin.loginIntercept(false);
      }
    },

    downloadTupianPackage(tupianItem) {
      if (fnLogin.checkLogin()) {
        this.$emit('downloadTupianPackage', tupianItem, 1);
      } else {
        fnLogin.loginIntercept(false);
      }
    },
    downloadTupianPackageSourceFiles(tupianItem) {
      if (fnLogin.checkLogin()) {
        this.$emit('downloadTupianPackageSourceFiles', tupianItem, 2);
      } else {
        fnLogin.loginIntercept(false);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@mixin PicPackageButton(
  $btnBgColor: transparent,
  $btnHoverBgColor:transparent,
) {
  width: 240px;
  height: 54px;
  line-height: 54px;
  text-align: center;
  background: $btnBgColor;
  border-radius: 27px;
  font-size: 20px;
  color: #2D2B33;
  @include ElementHover('', $btnHoverBgColor);
}

/* 第一个按钮定位 */
.tupian-btn-1 {
  //@include Position(1, 4, 50%, 144px);
  @include Position(1, 4, 50%, 144px);
  transform: translateX(-50%);

}

/* 第二个按钮定位 */
.tupian-btn-2 {
  @include Position(1, 4, 50%, 74px);
  transform: translateX(-50%);
}


.TupianDownBtn {
  @include Position(1, 4, 0, 0);
  width: 100%;
  height: 157px;
  transition: all 0.5s ease-in-out;

  @include Position(1, 4, 0, -200px);

  .tupian-btn-group {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .mask {
      display: inline-block;
      width: 100%;
      height: 100%;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.1500) 52%, rgba(0, 0, 0, 0.3000) 100%);
      border-radius: 0px 0px 14px 14px;
      @include Position(1, 5, 0, 0);
    }

    .tupian-btn {
      width: 240px;
      height: 54px;
      border-radius: 27px;
      font-size: 20px;
      text-align: center;
      line-height: 54px;
      position: relative;
      z-index: 5;


      &.free {
        background: #6969FF;
        color: $color-primary;
        background: rgba(255, 255, 255, 0.9);
        border: 1px solid #6969FF;
        @include Position(1, 4, 50%, 144px);
        transform: translateX(-50%);

        &:hover {
          background: rgba(255, 255, 255, 1);
        }

        &.COMPANY {
          border: 1px solid rgba(61, 66, 102, 1);
          color: rgba(61, 66, 102, 0.9);

          &:hover {
            //background: #7878FF;
          }
        }


      }

      &.file {
        background: #6969FF;
        color: #FFFFFF;
        @include Position(1, 4, 50%, 74px);
        transform: translateX(-50%);

        &:hover {
          background: #7878FF;
        }

        &.COMPANY {
          background: linear-gradient(133deg, #3D4266 0%, #292C42 100%);
          color: #FFE5CE;

          &:hover {
            background: linear-gradient(133deg, #292C42 0%, #3D4266 100%);
          }
        }

      }


    }

    @include Screen(1) {
      .free {
        @include Position(1, 5, 50%, -7px);
        width: 220px;
      }
      .file {
        @include Position(1, 5, 50%, 63px);
        width: 220px;
      }
    }
  }

  .tupian-package-btn-group {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .mask {
      display: inline-block;
      width: 100%;
      height: 100%;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.1500) 52%, rgba(0, 0, 0, 0.3000) 100%);
      border-radius: 0px 0px 14px 14px;
      @include Position(1, 5, 0, 0);
    }

    .tupian-btn {
      width: 240px;
      height: 54px;

      &.plain {

        background: #6969FF;
        border-radius: 27px;
        font-size: 20px;
        color: $color-primary;
        line-height: 54px;
        text-align: center;
        background: rgba(255, 255, 255, 0.9);
        border: 1px solid #6969FF;

        &:hover {
          background: rgba(255, 255, 255, 1);
        }
      }

      &.package-info {
        @include PicPackageButton(#F8CC44, #F9D057);

        .pic-price {
          color: #2D2B33;
          font-weight: bold;
          font-size: 0;

          .text-dollar {
            line-height: 24px;

            margin-left: 4px;
          }

          .text-price {
            line-height: 48px;
            font-size: 26px;
            font-weight: normal;
          }

          .pic-child-num {
            line-height: 17px;
            font-weight: normal;
            font-size: 16px;
            margin-left: 2px;
          }
        }
      }

      &.plain-down {
        @include PicPackageButton();
        background: rgba(255, 255, 255, 0.9000);
        border-radius: 27px;
        border: 1px solid #F8CC44;
        box-sizing: border-box;
        backdrop-filter: blur(30px);
        color: #FCBE00;
        @include ElementHover('', rgba(255, 255, 255, 1));
      }

      /* 带价格和张数的图片包按钮 */
      &.file-down {
        @include PicPackageButton(#F8CC44, #F9D057);
      }
    }

    .tupian-btn-1 {
      @include Position(1, 5, 50%, -7px);
      width: 220px !important;
    }

    .tupian-btn-2 {
      @include Position(1, 5, 50%, 63px);
      width: 220px !important;
    }
  }


}
</style>
